import React, { useEffect, useState } from "react";
import { ModalBody, Common, Label, Input, Select, DateRangeInput } from "@lainco/react-toolbox";
import { withCrudModal } from "../components/Modal";
import { InputNumber } from "../components/InputNumber";
import { useCandidates } from "../app/candidatesSlice";
import BankAccountBalance from "../model/BankAccountBalance";
import { groupBy } from "lodash";

export function BankAccountBalanceModalContent({ model, onChange }) {
  const [company, setCompany] = useState(model.account?.company?.id);
  const [bank, setBank] = useState(model.account?.bank?.id);
  const [banks, banksLoading] = useCandidates("banks");
  const [companies, companiesLoading] = useCandidates("companies");
  const [accounts, accountsLoading] = useCandidates("bankAccounts");

  const accountsById = React.useMemo(() => {
    return groupBy(accounts || [], (a) => a.id);
  }, [accounts]);

  useEffect(() => {
    onChange({ ...model, isAutomatic: false });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ModalBody>
      <Common.Grid cols="1fr 1fr" gap="1em">
        <Label text="Company">
          <Select
            value={company}
            onChange={(x) => {
              setCompany(x);
            }}
            options={companies}
            loading={companiesLoading}
          />
        </Label>
        <Label text="Bank">
          <Select
            value={bank}
            onChange={(x) => {
              setBank(x);
            }}
            options={banks}
            loading={banksLoading}
          />
        </Label>
        <Label text="Account" colSpan="2">
          <Select
            value={model.account?.id}
            onChange={(x) => {
              onChange({ ...model, account: accountsById[x] ? accountsById[x][0] : null });
            }}
            options={accounts
              ?.filter((a) => (company ? a.company?.id === company : true) && (bank ? a.bank?.id === bank : true))
              ?.map((x) => ({ id: x.id, name: x.shortName }))}
            loading={accountsLoading}
          />
        </Label>
        <Label text="Date">
          <DateRangeInput date={model.date} onDateSelected={(x) => onChange({ ...model, date: x })} />
        </Label>
        <Label text="Balance">
          <InputNumber value={model.balance} onChange={(x) => onChange({ ...model, balance: x })} />
        </Label>
      </Common.Grid>
    </ModalBody>
  );
}

export default withCrudModal(BankAccountBalanceModalContent, BankAccountBalance, "lg", false);
